const cards = [
  {
    title: '咒术回战 第二季',
    desc: '涩谷事变篇火热连载中，五条悟被封印，虎杖一行人面临史上最大危机',
    tag: '热血战斗',
    score: '9.7',
    views: '3580万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20illustration%20with%20dark%20urban%20fantasy%20theme%2C%20male%20characters%20with%20supernatural%20powers%20in%20dynamic%20fighting%20poses%2C%20dramatic%20red%20and%20black%20color%20palette%2C%20clean%20flat%20Japanese%20animation%20style%2C%20no%20text%20no%20watermark&width=400&height=560&seq=cards-01&orientation=portrait',
  },
  {
    title: '间谍过家家 第二季',
    desc: '福杰一家的温馨日常与秘密任务，安妮亚的校园生活笑料百出',
    tag: '喜剧日常',
    score: '9.5',
    views: '2890万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20illustration%20with%20warm%20family%20comedy%20theme%2C%20a%20family%20of%20three%20in%20elegant%20attire%20with%20playful%20expressions%2C%20soft%20pastel%20color%20palette%20with%20warm%20lighting%2C%20clean%20flat%20animation%20style%2C%20no%20text%20no%20watermark&width=400&height=560&seq=cards-02&orientation=portrait',
  },
  {
    title: '葬送的芙莉莲',
    desc: '勇者小队冒险结束后，精灵魔法使芙莉莲踏上了解人类情感的旅程',
    tag: '奇幻治愈',
    score: '9.8',
    views: '4120万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20illustration%20with%20fantasy%20adventure%20theme%2C%20elf%20female%20protagonist%20with%20staff%20in%20a%20beautiful%20meadow%20landscape%2C%20soft%20golden%20sunset%20lighting%2C%20emotional%20atmosphere%2C%20clean%20flat%20animation%20style%2C%20no%20text%20no%20watermark&width=400&height=560&seq=cards-03&orientation=portrait',
  },
  {
    title: '我推的孩子 第二季',
    desc: '演艺圈题材再掀高潮，阿库亚的复仇计划与舞台剧篇精彩上演',
    tag: '剧情悬疑',
    score: '9.4',
    views: '1960万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20illustration%20with%20showbiz%20entertainment%20theme%2C%20colorful%20stage%20spotlight%20with%20star%20performers%2C%20glamorous%20idol%20aesthetic%2C%20vibrant%20pink%20and%20gold%20color%20palette%2C%20clean%20flat%20animation%20style%2C%20no%20text%20no%20watermark&width=400&height=560&seq=cards-04&orientation=portrait',
  },
  {
    title: '怪兽8号',
    desc: '中年大叔变身最强怪兽，防卫队热血战斗与职场日常交织的科幻力作',
    tag: '科幻动作',
    score: '9.3',
    views: '1720万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20illustration%20with%20sci-fi%20monster%20battle%20theme%2C%20giant%20kaiju%20creature%20with%20glowing%20blue%20energy%20in%20destroyed%20cityscape%2C%20intense%20action%20atmosphere%2C%20cool%20blue%20and%20white%20color%20palette%2C%20clean%20flat%20animation%20style%2C%20no%20text%20no%20watermark&width=400&height=560&seq=cards-05&orientation=portrait',
  },
  {
    title: '药屋少女的呢喃',
    desc: '宫廷药师猫猫的推理日常，在华丽后宫中解开一个又一个谜团',
    tag: '古风推理',
    score: '9.6',
    views: '2340万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20poster%20style%20illustration%20with%20ancient%20Chinese%20palace%20mystery%20theme%2C%20female%20protagonist%20in%20traditional%20elegant%20attire%20among%20flowers%20and%20herbs%2C%20rich%20warm%20color%20palette%20with%20golden%20accents%2C%20clean%20flat%20animation%20style%2C%20no%20text%20no%20watermark&width=400&height=560&seq=cards-06&orientation=portrait',
  },
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">热门番剧</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">当前最受动漫迷欢迎的高分动漫番剧</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {cards.map((card, i) => (
            <div key={i} className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="relative aspect-[2/3] bg-background-200 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) target.parentElement.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2">
                  <span className="px-1.5 py-0.5 bg-accent-500 text-background-50 rounded text-xs font-bold">{card.score}</span>
                </div>
                <div className="absolute bottom-2 left-2 right-2">
                  <span className="px-1.5 py-0.5 bg-background-50/90 text-foreground-800 rounded text-xs font-semibold">{card.tag}</span>
                </div>
              </div>
              <div className="p-2 md:p-3">
                <h3 className="text-xs md:text-sm font-semibold text-foreground-900 mb-1 line-clamp-1">{card.title}</h3>
                <p className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line" style={{ width: '1em', height: '1em' }}></i>{card.views}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}